import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 0;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
`;